import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import { I18nProvider, useI18n } from "@/i18n/I18nContext";
import { useEffect } from "react";

const LangEffect = () => {
  const { dict } = useI18n();
  useEffect(() => {
    if (dict?.meta?.html_lang) {
      document.documentElement.lang = dict.meta.html_lang;
    }
  }, [dict]);
  return null;
};

const Layout = () => {
  return (
    <I18nProvider>
      <ScrollToTop />
      <LangEffect />
      <div className="min-h-screen flex flex-col bg-[#F8FAFC] text-[#0F172A]">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
};

export default Layout;
